/**
 * Shop My Ride - Vehicle Selector
 */

// Helper functions available globally
function getRideSaved() {
  // Try localStorage first
  try {
    const stored = localStorage.getItem('ride');
    if (stored) {
      return JSON.parse(stored);
    }
  } catch(e) {
    console.error('Failed to read from localStorage:', e);
  }

  // Fallback to cookie
  try {
    const match = document.cookie.match(/(?:^|;)\s*ride=([^;]+)/);
    if (match) {
      return JSON.parse(decodeURIComponent(match[1]));
    }
  } catch(e) {
    console.error('Failed to read from cookie:', e);
  }

  return null;
}

(() => {
  // Model index from metaobjects (set by Liquid template)
  const MODEL_INDEX = window.VEHICLE_MODEL_INDEX || {};

  // Get elements
  const makeEl = document.getElementById('smr-make');
  const modelEl = document.getElementById('smr-model');
  const universalEl = document.getElementById('smr-universal');
  const applyEl = document.getElementById('smr-apply');
  const clearEl = document.getElementById('smr-clear');
  const panel = document.getElementById('shop-my-ride-panel');
  const btn = document.getElementById('shop-my-ride-btn');
  const btnText = document.getElementById('shop-my-ride-text');

  if (!makeEl || !modelEl || !applyEl || !clearEl || !panel || !btn || !btnText) {
    console.warn('Shop My Ride: Required elements not found');
    return;
  }

  // Save ride to localStorage and cookie
  function saveRide(ride) {
    try {
      localStorage.setItem('ride', JSON.stringify(ride));
    } catch(e) {
      console.error('Failed to save to localStorage:', e);
    }

    try {
      document.cookie = `ride=${encodeURIComponent(JSON.stringify(ride))};path=/;max-age=31536000`;
    } catch(e) {
      console.error('Failed to save to cookie:', e);
    }
  }

  // Get saved ride from localStorage or cookie
  function getRide() {
    return getRideSaved();
  }

  // Clear saved ride from localStorage and cookie
  function clearRide() {
    try {
      localStorage.removeItem('ride');
    } catch(e) {
      console.error('Failed to clear from localStorage:', e);
    }

    try {
      document.cookie = 'ride=;path=/;max-age=0';
    } catch(e) {
      console.error('Failed to clear cookie:', e);
    }
  }

  // Update button text to show selected vehicle
  function updateButtonText() {
    const saved = getRide();

    if (saved?.make && saved?.model) {
      btnText.innerHTML = `
        <span class="shop-my-ride__button-text">
          <span class="shop-my-ride__button-label">My Ride</span>
          <span class="shop-my-ride__button-vehicle">${saved.make} ${saved.model}</span>
        </span>
      `;
    } else {
      btnText.textContent = 'Shop My Ride';
    }

    // Remove loading state and show button
    btn.classList.remove('loading');
    btn.classList.add('ready');
  }

  // Populate model dropdown based on selected make
  function populateModels(make) {
    modelEl.innerHTML = '<option value="">Select Model</option>';

    const models = MODEL_INDEX[make] || [];

    models.forEach(model => {
      const opt = document.createElement('option');
      opt.value = model;
      opt.textContent = model;
      modelEl.appendChild(opt);
    });

    modelEl.disabled = !models.length;
  }

  // Toggle panel visibility
  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const isHidden = panel.style.display === 'none';
    panel.style.display = isHidden ? 'block' : 'none';
    btn.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
  });

  // Close panel when clicking outside
  document.addEventListener('click', (e) => {
    if (!panel.contains(e.target) && e.target !== btn) {
      panel.style.display = 'none';
      btn.setAttribute('aria-expanded', 'false');
    }
  });

  // Handle make selection
  makeEl.addEventListener('change', () => {
    const make = makeEl.value;
    populateModels(make);
    modelEl.value = '';
    applyEl.disabled = true;
  });

  // Handle model selection
  modelEl.addEventListener('change', () => {
    applyEl.disabled = !modelEl.value;
  });

  // Handle apply button
  applyEl.addEventListener('click', () => {
    const make = makeEl.value;
    const model = modelEl.value;
    const universal = universalEl ? universalEl.checked : true;

    if (!make || !model) {
      return;
    }

    // Save selection
    saveRide({ make, model, universal });

    // Update button text
    updateButtonText();

    // Close panel
    panel.style.display = 'none';
    btn.setAttribute('aria-expanded', 'false');

    // Build filter URL using metafield filters
    const url = new URL(window.location.href);
    
    // Set Make (Selected + Universal)
    url.searchParams.delete('filter.p.m.custom.make');
    url.searchParams.append('filter.p.m.custom.make', make);
    if (universal && make !== 'Universal') {
      url.searchParams.append('filter.p.m.custom.make', 'Universal');
    }

    // Set Model (Selected + Universal)
    url.searchParams.delete('filter.p.m.custom.models');
    url.searchParams.append('filter.p.m.custom.models', model);
    if (universal && model !== 'Universal') {
      url.searchParams.append('filter.p.m.custom.models', 'Universal');
    }

    // Navigate to filtered collection
    location.href = url.toString();
  });

  // Handle clear button
  clearEl.addEventListener('click', () => {
    // Clear saved ride
    clearRide();

    // Reset form
    makeEl.value = '';
    modelEl.value = '';
    modelEl.disabled = true;
    applyEl.disabled = true;

    // Update button text
    updateButtonText();

    // Close panel
    panel.style.display = 'none';
    btn.setAttribute('aria-expanded', 'false');

    // Remove filters from URL and reload
    const url = new URL(window.location.href);
    url.searchParams.delete('filter.p.m.custom.make');
    url.searchParams.delete('filter.p.m.custom.models');

    location.href = url.toString();
  });

  // Hydrate from saved ride on page load
  const saved = getRide();
  if (saved?.make) {
    makeEl.value = saved.make;
    populateModels(saved.make);

    if (saved.model) {
      // Wait for models to populate
      setTimeout(() => {
        modelEl.value = saved.model;
        if (modelEl.value) {
          modelEl.disabled = false;
          applyEl.disabled = false;
        }
      }, 0);
    }

    if (universalEl && saved.hasOwnProperty('universal')) {
      universalEl.checked = saved.universal;
    }
  }

  // Update button text on load
  updateButtonText();
})();

/**
 * Mobile Menu Version
 */
(() => {
  const mobileBtn = document.getElementById('mobile-shop-my-ride-btn');
  const mobileBtnText = document.getElementById('mobile-shop-my-ride-text');
  const mobilePanel = document.getElementById('mobile-shop-my-ride-panel');
  const mobileMAKE = document.querySelector('[data-mobile-vehicle-make]');
  const mobileMODEL = document.querySelector('[data-mobile-vehicle-model]');
  const mobileUNIVERSAL = document.getElementById('mobile-smr-universal');
  const mobileAPPLY = document.querySelector('[data-mobile-vehicle-apply]');
  const mobileCLEAR = document.getElementById('mobile-smr-clear');

  if (!mobileBtn || !mobilePanel || !mobileMAKE || !mobileMODEL || !mobileAPPLY || !mobileCLEAR) {
    return; // Mobile nav not present
  }

  // Reuse MODEL_INDEX from metaobjects (set by Liquid template)
  const mobileModelIndex = window.VEHICLE_MODEL_INDEX || {};

  function populateMobileModels(make) {
    mobileMODEL.innerHTML = '<option value="">Select Model</option>';
    const models = mobileModelIndex[make] || [];

    models.forEach(model => {
      const opt = document.createElement('option');
      opt.value = model;
      opt.textContent = model;
      mobileMODEL.appendChild(opt);
    });

    mobileMODEL.disabled = !models.length;
  }

  function saveRide(ride) {
    try {
      localStorage.setItem('ride', JSON.stringify(ride));
      document.cookie = `ride=${encodeURIComponent(JSON.stringify(ride))};path=/;max-age=31536000`;
    } catch(e) {}
  }

  function getRide() {
    try {
      const stored = localStorage.getItem('ride');
      if (stored) return JSON.parse(stored);
    } catch(e) {}
    return null;
  }

  function clearRide() {
    try {
      localStorage.removeItem('ride');
      document.cookie = 'ride=;path=/;max-age=0';
    } catch(e) {}
  }

  // Update mobile button text to show selected vehicle
  function updateMobileButtonText() {
    const saved = getRide();

    if (saved?.make && saved?.model) {
      mobileBtnText.innerHTML = `
        <span class="mobile-vehicle-selector__button-label">My Ride</span>
        <span class="mobile-vehicle-selector__button-vehicle">${saved.make} ${saved.model}</span>
      `;
    } else {
      mobileBtnText.textContent = 'Shop By Vehicle';
    }

    // Remove loading state and show button
    mobileBtn.classList.remove('loading');
    mobileBtn.classList.add('ready');
  }

  // Toggle panel visibility
  mobileBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    const isExpanded = mobilePanel.style.display !== 'none';
    mobilePanel.style.display = isExpanded ? 'none' : 'block';
    mobileBtn.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
  });

  // Handle make selection
  mobileMAKE.addEventListener('change', () => {
    const make = mobileMAKE.value;
    populateMobileModels(make);
    mobileMODEL.value = '';
    mobileAPPLY.disabled = true;
  });

  // Handle model selection
  mobileMODEL.addEventListener('change', () => {
    mobileAPPLY.disabled = !mobileMODEL.value;
  });

  // Handle apply
  mobileAPPLY.addEventListener('click', () => {
    const make = mobileMAKE.value;
    const model = mobileMODEL.value;
    const universal = mobileUNIVERSAL ? mobileUNIVERSAL.checked : true;

    if (!make || !model) return;

    // Save selection
    saveRide({ make, model, universal });

    // Update button text
    updateMobileButtonText();

    // Close panel
    mobilePanel.style.display = 'none';
    mobileBtn.setAttribute('aria-expanded', 'false');

    // Build filter URL
    const url = new URL(window.location.href);
    
    // Set Make (Selected + Universal)
    url.searchParams.delete('filter.p.m.custom.make');
    url.searchParams.append('filter.p.m.custom.make', make);
    if (universal && make !== 'Universal') {
      url.searchParams.append('filter.p.m.custom.make', 'Universal');
    }

    // Set Model (Selected + Universal)
    url.searchParams.delete('filter.p.m.custom.models');
    url.searchParams.append('filter.p.m.custom.models', model);
    if (universal && model !== 'Universal') {
      url.searchParams.append('filter.p.m.custom.models', 'Universal');
    }

    location.href = url.toString();
  });

  // Handle clear button
  mobileCLEAR.addEventListener('click', () => {
    // Clear saved ride
    clearRide();

    // Reset form
    mobileMAKE.value = '';
    mobileMODEL.value = '';
    mobileMODEL.disabled = true;
    mobileAPPLY.disabled = true;

    // Update button text
    updateMobileButtonText();

    // Close panel
    mobilePanel.style.display = 'none';
    mobileBtn.setAttribute('aria-expanded', 'false');

    // Remove filters from URL and reload
    const url = new URL(window.location.href);
    url.searchParams.delete('filter.p.m.custom.make');
    url.searchParams.delete('filter.p.m.custom.models');

    location.href = url.toString();
  });

  // Load saved selection
  const saved = getRide();
  if (saved?.make) {
    mobileMAKE.value = saved.make;
    populateMobileModels(saved.make);

    if (saved.model) {
      setTimeout(() => {
        mobileMODEL.value = saved.model;
        if (mobileMODEL.value) {
          mobileMODEL.disabled = false;
          mobileAPPLY.disabled = false;
        }
      }, 0);
    }
    
    if (mobileUNIVERSAL && saved.hasOwnProperty('universal')) {
      mobileUNIVERSAL.checked = saved.universal;
    }
  }

  // Update button text on load
  updateMobileButtonText();
})();
